export default __webpack_public_path__ + "images/47_thumbnail.jpg";